import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BehaviorSubject } from "rxjs";
import { Subject } from "rxjs";
import { OrderDataImpl } from "shared/cubiq-model-multi-asset";
import { BmarkSummaryContainerComponent } from "../bmark-summary-container.component";
import { GridOptions, Column, ColDef, RowNode } from "ag-grid-community";
import { RiskSubscriptionType } from "shared/cubiq-services/lookup/model/impl/bmrisk/BaseBMRiskModel";
import { BfxBaseBlotter } from "app/bfx-base-blotter/bfx-base-blotter";
import { BmarkSummaryViewFilterType } from "../models/bmark-summary-view-filter-type.enum";

export class FilterAppliedStatusModel {
  constructor(
    public isFilterApplied: boolean,
    public filterConfiguration: string[],
    public viewFilterType: BmarkSummaryViewFilterType = BmarkSummaryViewFilterType.ALL,
  ) {
    this.isFilterApplied = isFilterApplied;
    this.filterConfiguration = filterConfiguration;
  }

  public get hasViewFilter(): boolean {
    return (
      BmarkSummaryViewFilterType.ACTIVE === this.viewFilterType ||
      BmarkSummaryViewFilterType.FILLED === this.viewFilterType
    );
  }
}

@Injectable()
export class BmarkSummaryUtilService {
  public summaryInstance: any = null;

  public quickFilterSubject: Subject<string> = new Subject<string>();

  private isFilterAppliedSubject: BehaviorSubject<FilterAppliedStatusModel> =
    new BehaviorSubject<FilterAppliedStatusModel>(null);
  public filterAppliedObs$: Observable<any> = this.isFilterAppliedSubject.asObservable();

  public isFilterApplied(isFilterAppliedValue: FilterAppliedStatusModel) {
    this.isFilterAppliedSubject.next(isFilterAppliedValue);
  }

  public doesQuickFilterPass(data: OrderDataImpl, type: RiskSubscriptionType): boolean {
    if (this.summaryInstance != null) {
      let summary: BmarkSummaryContainerComponent = this.summaryInstance;
      let text: string = null;

      try {
        if (summary.searchValue != null && (text = summary.searchValue.trim()).length > 0) {
          let tokens: string[] = text.toLowerCase().split(/[\s,]+/);
          let blotter: BfxBaseBlotter =
            type == RiskSubscriptionType.CLIENT
              ? summary.bmarkSummaryClientOrdersComponent.bmarkClientOrdersBlotter
              : summary.bmarkSummaryHedgeOrdersComponent.bmarkHedgeOrdersBlotter;
          let result: string = this.getQuickFilterData(data, blotter.gridOptions);
          result = result != null ? result.toLowerCase() : null;
          return result == null || tokens.find((token) => result.indexOf(token) < 0) == null;
        }
      } catch (ex) {
        logger.out.error("Error occurred checking quick filter data ", ex);
      }
    }

    return true;
  }

  protected getQuickFilterData(data: OrderDataImpl, gridOptions: GridOptions): string {
    let aggregatedText: string = null;

    if (gridOptions.api != null && gridOptions.columnApi != null) {
      aggregatedText = "";

      gridOptions.columnApi.getAllDisplayedColumns().forEach((column: Column) => {
        let columnDefinition: ColDef = column.getColDef();
        let field: string = columnDefinition.field;

        let params: any = {};
        params.api = gridOptions.api;
        params.colDef = columnDefinition;
        params.column = column;
        params.columnApi = gridOptions.columnApi;
        params.context = gridOptions.context;
        params.data = data;
        params.node = new RowNode();
        params.node.data = data;
        params.value = field != null ? data[field] : null;

        if (
          columnDefinition.valueGetter != null &&
          typeof columnDefinition.valueGetter !== "string"
        ) {
          params.value = columnDefinition.valueGetter(params);
        }

        if (columnDefinition.getQuickFilterText != null) {
          params.value = columnDefinition.getQuickFilterText(params);
        }

        if (params.value != null) {
          aggregatedText += params.value + " ";
        }
      });
    }

    return aggregatedText;
  }
}
